<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Estado de Cuenta</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-12 col-lg-6">
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label>Cuenta Bancaria</label>
                    <select class="form-control" autofocus="autofocus" v-model="current.cuenta_bancaria">
                      <option v-for="(c, key) in cuentas_bancarias" :value="c.id" :key="key">
                        {{ c.id }} - {{ c.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-6">
                  <label>Fecha inicio</label>
                  <input v-model="current.fechainicial" class="form-control" type="date" />
                </div>
                <div class="col-6">
                  <label>Fecha fin</label>
                  <input v-model="current.fechafinal" class="form-control" type="date" />
                </div>

              </div>
              <br />
              <div class="row">
                <div class="col-sm-12">
                  <button :disabled="
                    current.fechainicial == null ||
                    current.fechafinal == null ||
                    current.cuenta_bancaria == null
                  " @click="GenerarReporte()" type="button" class="btn btn-success btn-block">
                    <i class="fas fa-download"></i>
                    Generar Reporte
                  </button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

import DynamicService from "@/services/commons/DynamicService";
import UsuariosService from "@/services/accounts/UsuariosService.js";

export default {
  components: {},
  data() {
    return {
      cuentas_bancarias: [],
      current: {
        cuenta_bancaria: null,
        fechainicial: null,
        fechafinal: null,
        usuario: null,
      },
    };
  },
  mounted() {
    this.refreshCuentaBancaria();
    this.usuarioGet();
    this.current.fechainicial = new Date();
    this.current.fechafinal = new Date();
  },
  methods: {
    usuarioGet() {
      UsuariosService.profile().then((response) => {
        this.current.usuario = response.data.id;
      });
    },
    refreshCuentaBancaria() {
      let self = this;
      DynamicService.fetch("cat", "cuenta-bancaria", {
        quitar_paginacion: true,
      }).then((res) => {
        self.cuentas_bancarias = res.data;
      });
    },
    GenerarReporte() {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      const params = `&fechainicial=${self.current.fechainicial}&fechafinal=${self.current.fechafinal}&cuentabancariaid=${self.current.cuenta_bancaria}&usuario=${self.current.usuario}`;
      const reporte = `/cat/reporte/?&report_format=pdf&report_name=bancos/estado_cta/estado_cta_b_interno.jrxml`;
      window.open(`${baseApiUrl}${reporte}${params}`);
    },
  },
};
</script>
